<main class="rh">
  <!-- HERO -->
  <section class="rh-hero">
    <div class="rh-blob rh-blob-1"></div>
    <div class="rh-blob rh-blob-2"></div>
    <div class="rh-grid-bg"></div>
    <div class="container rh-hero-inner">
      <div class="rh-hero-copy">
        <span class="rh-eyebrow"><i class="fab fa-whatsapp"></i> A ResilienceSoft Product</span>
        <h1>
          <span class="rh-brand">ResilioHub</span>
          WhatsApp Business API, CRM &amp; <span class="rh-grad-text">AI Automation</span> Platform
        </h1>
        <p class="rh-lead">
          <strong>ResilioHub is an AI-powered WhatsApp Business API and customer engagement platform developed by
            ResilienceSoft.</strong>
          It helps businesses manage customer conversations, organize leads, automate workflows, run broadcast
          campaigns and deploy AI chatbots from one unified platform.
        </p>
        <p class="rh-sub">
          Designed for businesses that want to improve customer communication and sales efficiency, ResilioHub
          combines WhatsApp messaging, CRM, team collaboration, chatbot automation and integrations to help teams
          manage customer interactions more effectively. Whether you are a small business, growing company,
          marketing agency or enterprise, ResilioHub helps you streamline customer communication, manage enquiries
          and build automated business workflows.
        </p>
        <div class="rh-cta-row">
          <a class="rh-btn rh-btn-primary" [href]="productUrl" target="_blank" rel="noopener">
            Explore ResilioHub <i class="fas fa-arrow-right"></i>
          </a>
          <a class="rh-btn rh-btn-ghost" routerLink="/contact-us">
            <i class="fas fa-headset"></i> Talk to Our Team
          </a>
        </div>
        <ul class="rh-chips">
          <li *ngFor="let chip of heroChips"><i [class]="chip.icon"></i>{{ chip.label }}</li>
        </ul>
      </div>

      <!-- Animated phone mockup -->
      <div class="rh-hero-visual" aria-hidden="true">
        <div class="rh-ring rh-ring-1"></div>
        <div class="rh-ring rh-ring-2"></div>
        <div class="rh-phone">
          <div class="rh-phone-notch"></div>
          <div class="rh-chat-head">
            <div class="rh-avatar"><i class="fas fa-robot"></i></div>
            <div>
              <b>ResilioHub Assistant</b>
              <small><span class="rh-dot"></span> online</small>
            </div>
          </div>
          <div class="rh-chat-body">
            <div class="rh-msg in m1">Hi! I'd like to know your plans 👋</div>
            <div class="rh-msg out m2">Hello! I'm the AI assistant. May I have your name &amp; business type?</div>
            <div class="rh-msg in m3">Priya, I run an online store 🛍️</div>
            <div class="rh-msg out m4">Thanks Priya! Lead saved ✅ Connecting you to our sales team…</div>
            <div class="rh-typing m5"><span></span><span></span><span></span></div>
          </div>
          <div class="rh-chat-input"><span>Type a message</span><i class="fas fa-paper-plane"></i></div>
        </div>
        <div class="rh-float rh-float-1"><i class="fas fa-user-plus"></i><div><b>New lead</b><small>Stage: Qualified</small></div></div>
        <div class="rh-float rh-float-2"><i class="fas fa-bullhorn"></i><div><b>Campaign sent</b><small>Approved template</small></div></div>
        <div class="rh-float rh-float-3"><i class="fas fa-random"></i><div><b>Chat assigned</b><small>Sales team</small></div></div>
      </div>
    </div>
  </section>

  <!-- WHAT IS -->
  <section class="rh-section rh-what">
    <div class="container rh-split">
      <div class="rh-hub reveal" aria-hidden="true">
        <div class="rh-hub-core">
          <i class="fab fa-whatsapp"></i>
          <span>ResilioHub</span>
        </div>
        <div class="rh-orbit">
          <div class="rh-node" *ngFor="let node of hubNodes; let i = index" [style.--i]="i">
            <div class="rh-node-inner"><i [class]="node.icon"></i><small>{{ node.label }}</small></div>
          </div>
        </div>
      </div>
      <div class="reveal">
        <span class="rh-kicker">Overview</span>
        <h2 class="rh-h2">What Is <span class="rh-grad-text">ResilioHub?</span></h2>
        <p>ResilioHub is a WhatsApp CRM and business messaging platform that brings customer conversations, contact
          management, sales workflows and automation together in one place.</p>
        <p>Built by ResilienceSoft, a software development and technology solutions company, ResilioHub helps
          businesses manage WhatsApp Business API communications, organize customer information, coordinate sales
          and support teams, and automate repetitive tasks.</p>
        <p>Instead of managing customer enquiries across disconnected tools, businesses can use ResilioHub to
          centralize conversations, assign chats to team members, manage leads, create automated responses and
          monitor campaign performance.</p>
        <p class="rh-highlight"><i class="fas fa-route"></i> The platform is designed to support customer engagement
          throughout the business journey, from the first enquiry to sales follow-ups and ongoing customer support.</p>
      </div>
    </div>
  </section>

  <!-- FEATURES -->
  <section class="rh-section rh-features">
    <div class="container">
      <div class="rh-head reveal">
        <span class="rh-kicker">Capabilities</span>
        <h2 class="rh-h2">Key Features of <span class="rh-grad-text">ResilioHub</span></h2>
        <p>Everything your team needs to message, sell, support and automate — on one connected platform.</p>
      </div>
      <div class="rh-bento">
        <article class="rh-feature reveal" *ngFor="let f of features; let i = index" [class.wide]="f.wide"
          [style.--d]="(i % 3) * 80 + 'ms'">
          <div class="rh-feature-icon"><i [class]="f.icon"></i></div>
          <span class="rh-feature-num">{{ (i + 1).toString().padStart(2, '0') }}</span>
          <h3>{{ f.title }}</h3>
          <p>{{ f.text }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- BENEFITS -->
  <section class="rh-section rh-benefits">
    <div class="rh-grid-bg light"></div>
    <div class="container">
      <div class="rh-head reveal">
        <span class="rh-kicker light">Why it matters</span>
        <h2 class="rh-h2 light">Benefits of Using ResilioHub for Your Business</h2>
      </div>
      <div class="rh-benefit-grid">
        <article class="rh-benefit reveal" *ngFor="let b of benefits; let i = index" [style.--d]="(i % 3) * 90 + 'ms'">
          <div class="rh-benefit-top">
            <i [class]="b.icon"></i>
            <span>{{ (i + 1).toString().padStart(2, '0') }}</span>
          </div>
          <h3>{{ b.title }}</h3>
          <p>{{ b.text }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- WHO CAN USE -->
  <section class="rh-section rh-audience">
    <div class="container">
      <div class="rh-head reveal">
        <span class="rh-kicker">Industries</span>
        <h2 class="rh-h2">Who Can Use <span class="rh-grad-text">ResilioHub?</span></h2>
        <p>ResilioHub can support businesses and teams that rely on messaging for customer acquisition, sales,
          service and retention.</p>
      </div>
      <div class="rh-tabs reveal">
        <div class="rh-tab-list" role="tablist">
          <button type="button" role="tab" *ngFor="let a of audiences; let i = index" class="rh-tab"
            [class.active]="activeAudience === i" [attr.aria-selected]="activeAudience === i"
            (click)="setAudience(i)" (mouseenter)="setAudience(i)">
            <i [class]="a.icon"></i><span>{{ a.title }}</span>
          </button>
        </div>
        <div class="rh-tab-panels">
          <article class="rh-panel" *ngFor="let a of audiences; let i = index" [class.active]="activeAudience === i"
            role="tabpanel">
            <div class="rh-panel-icon"><i [class]="a.icon"></i></div>
            <h3>{{ a.title }}</h3>
            <p>{{ a.text }}</p>
            <ul><li *ngFor="let t of a.tags"><i class="fas fa-check"></i>{{ t }}</li></ul>
          </article>
        </div>
      </div>
    </div>
  </section>

  <!-- WHY CHOOSE -->
  <section class="rh-section rh-why">
    <div class="container rh-split">
      <div class="reveal">
        <span class="rh-kicker">Built by experts</span>
        <h2 class="rh-h2">Why Choose ResilioHub by <span class="rh-grad-text">ResilienceSoft?</span></h2>
        <p>ResilienceSoft develops software and technology solutions for businesses seeking to improve operations,
          customer engagement and digital capabilities.</p>
        <p>ResilioHub extends this expertise into business messaging by bringing WhatsApp CRM, automation, team
          collaboration and customer communication tools into one platform.</p>
        <p>Businesses can explore ResilioHub as a dedicated messaging and automation product while working with
          ResilienceSoft for relevant custom software development, API integrations and technology implementation
          requirements.</p>
        <p class="rh-muted">Explore the platform, available features and current plans at
          <a [href]="productUrl" target="_blank" rel="noopener">https://resiliohub.com/</a>.</p>
      </div>
      <div class="rh-adv-card reveal">
        <h3>Key advantages include:</h3>
        <ul>
          <li *ngFor="let adv of advantages; let i = index" [style.--d]="i * 70 + 'ms'">
            <span class="rh-check"><i class="fas fa-check"></i></span>{{ adv }}
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- VS TRADITIONAL -->
  <section class="rh-section rh-vs">
    <div class="container">
      <div class="rh-head reveal">
        <span class="rh-kicker">Comparison</span>
        <h2 class="rh-h2">ResilioHub vs. Traditional Customer Communication Tools</h2>
        <p>Traditional customer communication often involves separate applications for messaging, lead tracking,
          team coordination and reporting. ResilioHub brings supported messaging channels, CRM functionality,
          automation and team collaboration into a more connected workflow.</p>
      </div>
      <div class="rh-vs-wrap reveal">
        <div class="rh-vs-col old">
          <div class="rh-vs-title"><i class="fas fa-puzzle-piece"></i> Traditional tools</div>
          <ul><li *ngFor="let t of traditional"><i class="fas fa-times"></i>{{ t }}</li></ul>
        </div>
        <div class="rh-vs-badge">VS</div>
        <div class="rh-vs-col new">
          <div class="rh-vs-title"><i class="fab fa-whatsapp"></i> ResilioHub</div>
          <ul><li *ngFor="let t of connected"><i class="fas fa-check"></i>{{ t }}</li></ul>
        </div>
      </div>
      <div class="rh-vs-notes reveal">
        <p>Businesses can use this approach to reduce fragmented communication, improve lead visibility and
          establish more consistent processes for handling customer enquiries.</p>
        <p>The right configuration depends on the business's messaging volume, integration requirements, team
          structure and automation needs.</p>
      </div>
    </div>
  </section>

  <!-- FAQ -->
  <section class="rh-section rh-faq">
    <div class="rh-blob rh-faq-blob-1"></div>
    <div class="rh-blob rh-faq-blob-2"></div>
    <div class="container">
      <div class="rh-head reveal">
        <span class="rh-kicker">FAQ</span>
        <h2 class="rh-h2">Frequently Asked Questions About <span class="rh-grad-text">ResilioHub</span></h2>
        <div class="rh-faq-search">
          <i class="fas fa-search"></i>
          <input type="search" placeholder="Search a question… e.g. chatbot, API, team" aria-label="Search FAQs"
            [value]="faqQuery" (input)="faqQuery = $any($event.target).value" />
          <span class="rh-faq-count">{{ filteredFaqs.length }} / {{ faqs.length }}</span>
        </div>
      </div>

      <div class="rh-faq-wrap">
        <div class="rh-faq-list reveal">
          <div class="rh-qa" *ngFor="let f of filteredFaqs" [class.open]="openFaq === f.q">
            <button type="button" class="rh-qa-q" (click)="toggleFaq(f.q)" [attr.aria-expanded]="openFaq === f.q"
              [attr.aria-controls]="'rh-faq-' + faqs.indexOf(f)">
              <span class="rh-qa-num">{{ (faqs.indexOf(f) + 1).toString().padStart(2, '0') }}</span>
              <h3>{{ f.q }}</h3>
              <span class="rh-qa-icon"><i class="fas fa-plus"></i></span>
            </button>
            <div class="rh-qa-a" [id]="'rh-faq-' + faqs.indexOf(f)" role="region">
              <div class="rh-qa-a-inner"><p>{{ f.a }}</p></div>
            </div>
          </div>
          <div class="rh-faq-empty" *ngIf="!filteredFaqs.length">
            <i class="far fa-comment-dots"></i>
            <p>No questions match “{{ faqQuery }}”. Ask our team directly — we reply fast.</p>
          </div>
        </div>

        <aside class="rh-faq-help reveal">
          <div class="rh-help-chat" aria-hidden="true">
            <div class="rh-help-bubble in">Does it work with my CRM? 🤔</div>
            <div class="rh-help-bubble out">Yes — via APIs, webhooks &amp; integrations ✅</div>
          </div>
          <h3>Still have questions?</h3>
          <p>Talk to the ResilienceSoft team about features, integrations or a custom setup for your business.</p>
          <a class="rh-btn rh-btn-wa" href="https://wa.me/+919109911372" target="_blank" rel="noopener">
            <i class="fab fa-whatsapp"></i> Chat on WhatsApp
          </a>
          <a class="rh-btn rh-btn-outline" routerLink="/contact-us">Ask a Question <i class="fas fa-arrow-right"></i></a>
        </aside>
      </div>
    </div>
  </section>

  <!-- GET STARTED -->
  <section class="rh-section rh-final">
    <div class="container">
      <div class="rh-final-card reveal">
        <div class="rh-blob rh-blob-3"></div>
        <h2>Get Started with ResilioHub</h2>
        <p>Bring customer messaging, lead management and business automation into a more connected workflow with
          ResilioHub.</p>
        <p>Explore how WhatsApp CRM, shared team inboxes, broadcast campaigns, AI chatbots and workflow automation can
          support your business communication requirements.</p>
        <div class="rh-cta-row center">
          <a class="rh-btn rh-btn-light" [href]="productUrl" target="_blank" rel="noopener">
            <i class="fab fa-whatsapp"></i> Visit ResilioHub
          </a>
          <a class="rh-btn rh-btn-outline" routerLink="/contact-us">Book a Consultation</a>
        </div>
        <p class="rh-final-foot">
          <strong>Developed by ResilienceSoft</strong> – Software Development, Business Automation and Digital
          Technology Solutions.
          <a routerLink="/">Learn more about ResilienceSoft</a>
        </p>
      </div>
    </div>
  </section>
</main>
